module.exports = __webpack_public_path__ + "img/ic-contact-line.bcd2d9a6.png";